// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ipkX","name":"styles_name__1xVQQ","phone":"styles_phone__1SMTm"};